import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductIndexItemInterface } from "../../common/interfaces/apiV2/shared/ProductIndexItemInterface";
import { SearchProductsResult } from "../../common/api/search";

interface SearchPageInterface {
    machines: ProductIndexItemInterface[];
    accessories: ProductIndexItemInterface[];
    old_models: ProductIndexItemInterface[];
    resultInputValue: string;
    resultCount: number;
    isLoading: boolean;
}

const initialState: SearchPageInterface = {
    machines: [],
    accessories: [],
    old_models: [],
    resultInputValue: "",
    resultCount: 0,
    isLoading: false,
};

const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        mapSearchResults: (
            state,
            action: PayloadAction<SearchProductsResult | undefined>,
        ) => {
            if (action.payload) {
                state.machines = action.payload.machines;
                state.accessories = action.payload.accessories;
                state.old_models = action.payload.old_models;
            }
        },
        setSearchingVariables: (
            state,
            action: PayloadAction<{
                resultValue?: string;
                isLoading?: boolean;
                resultCount?: number;
                clearResults?: boolean;
            }>,
        ) => {
            if (action.payload.resultValue) {
                state.resultInputValue = action.payload.resultValue;
            }

            if (typeof action.payload.isLoading === "boolean") {
                state.isLoading = action.payload.isLoading;
            }

            if (typeof action.payload.resultCount === "number") {
                state.resultCount = action.payload.resultCount;
            }

            if (action.payload.clearResults) {
                state.machines = [];
                state.accessories = [];
                state.old_models = [];
            }
        },
    },
});

export const { mapSearchResults, setSearchingVariables } = searchSlice.actions;

export const searchReducer = searchSlice.reducer;

export { useLazySearchProductsQuery } from "../../common/api/search";
